/**
 * @fileoverview Javascript for the social Post Box
 * Depended on Social/_post-box.html
 * @author Paige Ponzeka (pponzeka@yext.com)
 */
goog.provide('yext.social.PostBox');
goog.provide('yext.social.SocialPartner');
goog.provide('yext.social.SocialPermissions');

goog.require('yext');
goog.require('yext.dam.assetselector');
goog.require('yext.dam.assetselector.events');
goog.require('yext.dam.assetselector.usage');
goog.require('yext.dam.routes');
goog.require('yext.dialog');
goog.require('yext.fileupload');
goog.require('yext.location.photodestination');
goog.require('yext.notify');
goog.require('yext.social.partners');
goog.require('yext.social.post.LocationSelector');
goog.require('yext.social.post.actions');
goog.require('yext.social.post.dialogs.MissingAccountsDialog');
goog.require('yext.social.post.dialogs.MissingPermissionsDialog');
goog.require('yext.social.post.dialogs.MissingFieldsDialog');
goog.require('yext.social.post.dialogs.NoLinkedAccountDialog');
goog.require('yext.social.post.dialogs.SuccessDialog');
goog.require('yext.social.scheduledpostdialog');
goog.require('yext.storm.routesDEPRECATED');
goog.require('yext.youtube');
goog.require('yext.socialstorm.routes');

/**
 * @constructor
 * @param {string} name
 * @param {number} minChars
 * @param {number} maxChars
 */
yext.social.SocialPartner = function(name, minChars, maxChars) {
  this.name = name;
  this.minChars = minChars;
  this.maxChars = maxChars;
};

/**
 * @constructor
 * @param {!Array<number>} disabledLocationFields
 * @param {!Array<number>} locationsWithMaxChars
 * @param {!Array<number>} locationsWithMinChars
 */
yext.social.SocialPermissions = function(disabledLocationFields,
  locationsWithMaxChars,
  locationsWithMinChars) {
  this.disabledLocationFields = disabledLocationFields;
  this.locationsWithMaxChars = locationsWithMaxChars;
  this.locationsWithMinChars = locationsWithMinChars;
};

/**
 * Post Box
 * @constructor
 */
yext.social.PostBox = function(options) {
  this.options = $.extend(true, {}, options);
  this.$postForm = $('#fb-post-form');
  this.$postBox = $('.js-post-box-container');
  this.$postSubmitBtn = $('.js-post-box-action');
  this.$postMessage = $('.js-post-message');
  this.assetUsage = goog.module.get('yext.dam.assetselector.usage').forSocialPosting();

  this.lookForUrls_ = true;
  this.requiresApproval = this.$postBox.data('requiresApproval');
  this.url_ = null;
  if (options && options.hasScheduledPosting) {
    this.scheduledPostDialog = yext.social.scheduledpostdialog.init();
  }
  this.locationSelector = new yext.social.post.LocationSelector(
    this.$postForm,
    this.updateLocationScope.bind(this));

  this.missingAccountsDialog = new yext.social.post.dialogs.MissingAccountsDialog(
    this.submitPost.bind(this)).init();
  this.missingPermissionsDialog = new yext.social.post.dialogs.MissingPermissionsDialog(
    this.submitPost.bind(this)).init();
  this.missingFieldsDialog = new yext.social.post.dialogs.MissingFieldsDialog(
    this.submitPost.bind(this)).init();
  this.noLinkedAccountDialog = new yext.social.post.dialogs.NoLinkedAccountDialog().init();
  this.successDialog = new yext.social.post.dialogs.SuccessDialog().init();

  this.init();
};

/** @type {SocialPermissions} */
yext.social.PostBox.socialPermissions;

/** @type {!Object<number, SocialPartner>} */
yext.social.PostBox.socialPartners;

/**
 * @param {map[Number]yext.social.SocialPartner} socialPartners
 * @param {yext.social.SocialPermissions} socialPermissions
 */
yext.social.PostBox.init = function(socialPartnersParam, socialPermissionsParam) {
  yext.social.PostBox.socialPartners = socialPartnersParam;
  yext.social.PostBox.socialPermissions = socialPermissionsParam;
};

/**
 * Intialize the Post Box
 */
yext.social.PostBox.prototype.init = function() {
  yext.location.photodestination.init();
  yext.dam.assetselector.init();
  this.bindActions();
  this.bindPhotoActions();
  this.bindLinkActions();
  this.bindProfileFields();
  this.bindInputListener();
  this.initPartnerIcons();
  if (this.options.alwaysOpened) {
    this.setPostMessageAlwaysOpened();
    $('.fb-post-wrapper').removeClass('minimized');
  }
};

/**
 * Initialize partner Icons if there is a default location selected to start
 */
yext.social.PostBox.prototype.initPartnerIcons = function() {
  if (this.options.selectedLocationId) {
    var partnerIds = yext.social.partners.locationsToPartnerIds[this.options.selectedLocationId];
    this.updatePartnerIcons(partnerIds, ($.inArray( window.WIDGETS_ID, partnerIds)>= 0));
  }
};

/**
 * Updates Partner Icons to display icons available to given locations
 * @param {array} partnerIds an array of partner ids available
 * @param {boolean} hasWidgetsEnabled boolean to indicate if widgets icon should be enabled.
 */
yext.social.PostBox.prototype.updatePartnerIcons = function(partnerIds, hasWidgetsEnabled) {
  $('.social-partner-icon.network-logo-small.js-tooltip').hide();
  yext.social.PostBox.toggleWidgetIcon(!hasWidgetsEnabled);
  this.updateIcons(partnerIds, hasWidgetsEnabled);
};

/**
 * Updates the UI for a new location scope
 *
 * @param {!Object} data Object containing the list of partnerIds and whether
 *                      the location scope has social widgets
 * @param {Function} cb Function to update the location scope display
 */
yext.social.PostBox.prototype.updateLocationScopeDisplay = function(data, cb) {
  if (yext.isFunction(cb)) {
    cb(true /* success */);
  }

  this.$postForm.find('.js-location-post-details')
    .text(this.locationSelector.getDescriptiveText());
  this.$postForm.find('.js-folder-id').val(this.locationSelector.getFolderId());
  this.$postForm.find('.js-location-id').val(this.locationSelector.getLocationId());
  this.$postForm.find('.js-uses-selector').val(true);

  if (!data) {
    if (yext.social.partners.hasSocialWidgets) {
      yext.social.PostBox.toggleWidgetIcon(false);
    }
  } else {
    this.updatePartnerIcons(data['partners'], data['hasSocialWidgets']);
  }
};

/**
 * Updates the post based on the new location scope
 *
 * @param {!Object} data Object containing the list of partnerIds and whether
 *                      the location scope has social widgets
 * @param {Function} cb Function to update the location scope display
 */
yext.social.PostBox.prototype.updateLocationScope = function(data, cb) {
  if (!yext.isFunction(cb)) {
    throw new TypeError('PostBox.updateLocationScope: Invalid cb; must be a function');
  }
  var self = this;

  if (this.asset && this.asset.id) {
    $.ajax({
      url: goog.module.get('yext.dam.routes').default.validateAssetScope(),
      type: 'get',
      data: {
        'assetId': this.asset.id,
        'locationSearchParam': this.locationSelector.encodeLocationSearchParam(),
      },
    })
      .done(function(resp) {
        if (resp.matchesAssetScope) {
          self.updateLocationScopeDisplay(data, cb);
        } else {
          yext.dialog.showSubmitDialog({
            title: yext.msg('Invalid Asset'),
            message: yext.msg(
              'The photo asset you have selected for your post is not available for the selected ' +
            'locations. If you continue, the selected asset will be cleared.'),
            submitButtonText: yext.msg('OK'),
            onSubmit: function() {
              self.updateLocationScopeDisplay(data, cb);
              self.$postForm.find('.fb-remove-photo').click();
            },
            onCancel: function() {
              cb(false /* success */);
            },
          });
        }
      })
      .fail(function(resp) {
        yext.notify.showError(
          yext.msg('There was an error while updating your post\'s locations. Please try again'));
        cb(false /* success */);
      });
  } else {
    self.updateLocationScopeDisplay(data, cb);
  }
};

/**
 * Bind Post Actions On Submit
 */
yext.social.PostBox.prototype.bindActions = function() {
  var self = this;
  var $postWrap = $('#fb-post-div');
  var $postMessageWrapper = $('.fb-post-wrapper');
  var $postFooter = $('#post-footer');
  var blurMessageHeight = $postMessageWrapper.height();
  var autoMessageHeight;
  var alwaysOpened = false;
  var dialogPropagation;

  $postMessageWrapper.css('height', 'auto');
  autoMessageHeight = $postMessageWrapper.height();
  $postMessageWrapper.height(blurMessageHeight);

  // Submit action
  this.$postForm.find('.submit').click(function(e) {
    e.stopPropagation();
    if ($(this).hasClass('disabled')) {
      return;
    }
    self.submitPost();
  });

  // Schedule Post Action
  if (this.options.hasScheduledPosting) {
    this.$postForm.find('.js-schedule-post-btn').click(function(e) {
      var $this = $(this);
      e.stopPropagation();

      if ($this.hasClass('disabled')) {
        return;
      }

      self.$postForm.find('.fb-post-box-container')
        .toggleClass('fb-post-box-container-schedule');

      $this.toggleClass('btn-active');
      $this.find('.js-schedule-clock').toggleClass('icon-clock').toggleClass('icon-clock-white');
      if ($this.hasClass('btn-active')) {
        self.scheduledPostDialog.showDialog();
      } else {
        self.scheduledPostDialog.hideDialog();
      }
    });
  }

  // bind cancel post and revert all input
  this.$postForm.find('.js-cancel-post').click(function() {
    self.resetPostBox();
    self.closePostMessage();
  });

  // bind partner selector
  this.$postForm.find('.social-partner-icon').on('click', function() {
    $(this).toggleClass('disabled');
    self.updatePartnerStatus();
  });

  this.$postMessage.focus(function() {
    if (!alwaysOpened) {
      $postMessageWrapper.animate({
        height: autoMessageHeight,
      });
      slideShow($postFooter);
      $postMessageWrapper.removeClass('minimized');
    }
  });

  /**
   * Closes post message box
   */
  self.closePostMessage = function() {
    if (!alwaysOpened) {
      $postMessageWrapper.animate({
        height: blurMessageHeight,
      });
      $postFooter.slideUp();
      $postMessageWrapper.addClass('minimized');
    }
  };

  /**
   * Sets message box as always opened
   */
  self.setPostMessageAlwaysOpened = function() {
    alwaysOpened = true;
    $postMessageWrapper.css('height', 'auto');
    $postFooter.show();
  };

  /**
   * Slides down an element and then animates its opacity
   *
   * @param {!jQuery} $el Element that should be slid and shown
   */
  var slideShow = function($el) {
    if (!$el.is(':visible')) {
      $el
        .css('opacity', 0)
        .slideDown( function() {
          $el.animate({
            opacity: 1,
          }, 200);
        });
    }
  };
};

/**
 * Bind listeners for adding a link to a post
 */
yext.social.PostBox.prototype.bindLinkActions = function() {
  var self = this;
  // Listen for URLs in the text area.  We listen to paste events
  // separately so that we can require a space after urls when typing
  // but allow the urls directly when pasting.
  this.$postMessage.bind('input keyup', function() {
    var val = self.$postMessage.val();
    if (val.length === 0) {
      self.lookForUrls_ = !self.hasPhoto_;
      return;
    }
    if (!/\s$/.test(val)) {
      return;
    }
    var match = val.match(yext.CONTAINS_SIMPLE_URL_REGEX);
    if (match) {
      self.urlDetected(match[0]);
    }
  });

  this.$postMessage.bind('paste', function() {
    setTimeout(function() {
      var match = self.$postMessage.val().match(yext.CONTAINS_SIMPLE_URL_REGEX);
      if (match) {
        self.urlDetected(match[0]);
      }
    }, 0);
  });

  this.$postBox.find('.fb-link-remove-button').click(function(e) {
    e.preventDefault();
    self.resetLink();
    self.maybeEnableSubmit();
  });
};

yext.social.PostBox.prototype.uploadPhotoDone = function(data) {
  data = data || {};
  var photoUrl = data['url'] || null;
  if (photoUrl) {
    var $photo = this.$postBox.find('.fb-photo-wrapper');
    var $img = $photo.find('img');

    this.uploadedPhotoUrl = photoUrl;
    this.photoWidth = data['width'];
    this.photoHeight = data['height'];
    $img.attr('src', photoUrl).show();
  } else {
    // silently fail. it will be retried when user actually submits the post
  }
};

yext.social.PostBox.prototype.abortPhotoUploadAjaxRequest = function() {
  if (this.uploadPhotoAjaxRequest) {
    this.uploadPhotoAjaxRequest.abort();
  }
};

/**
 * Listeners for PostBox Actions
 */
yext.social.PostBox.prototype.bindPhotoActions = function() {
  var self = this;

  var $photo = this.$postBox.find('.fb-photo-wrapper');
  var $img = $photo.find('img');
  var $nophoto = $photo.find('.photo-single-nophoto');
  var $message = this.$postBox.find('.fb-post-wrapper');
  var $fbPhoto = this.$postBox.find('.fb-link-photo');

  this.$postBox.find('.js-gallery-add-photo').click(function() {
    if ($fbPhoto.hasClass('disabled')) {
      return false;
    }
    yext.dam.assetselector.show({
      type: yext.dam.assetselector.types.PHOTO,
      includeUsedAssets: true,
      locationSearchParam: self.locationSelector.encodeLocationSearchParam(),
      usageType: this.assetUsage,
    },
    'socialPostPhoto',
    false); // photos do not require approval for social post

    $(yext.dam.assetselector.events).on('added.assetselector', function(e, asset) {
      var fileName;
      var croppedImage;
      var photoUrl = asset.photoUrl;
      var assetId = asset.id;
      var sourceUrl = asset.sourceUrl;
      var shoulUploadFile = asset.file && !asset.croppedImage;

      self.removeUploadedPhoto();
      self.abortPhotoUploadAjaxRequest();

      if (shoulUploadFile) {
        var uploadFile = {
          action: yext.socialstorm.routes.SocialPost.uploadPhoto(),
          files: [asset.file],
          fileInputs: [asset.fileInputs],
          dataType: 'json',
          done: self.uploadPhotoDone.bind(self),
          error: self.uploadPhotoDone.bind(self),
        };

        self.uploadPhotoAjaxRequest = yext.fileupload.upload(uploadFile);
      } else if (asset.croppedImage) {
        croppedImage = asset.croppedImage;
        if (!asset.file) {
          fileName = asset.photoUrl;
          photoUrl = asset.photoUrl;
        }

        self.croppedImage = {
          'encodedString': asset.croppedImage,
          'fileName': fileName,
        };
      }
      $nophoto.hide();

      self.asset = asset;

      self.hasPhoto_ = true;
      self.lookForUrls_ = false;
      $('.fb-add').hide();
      $('.fb-replace').show();
      $photo.show();

      // Adjust text area. For now, using fixed, although easy to
      // imagine sizing these around the photo with proper callback
      // situation.
      $message.css('margin-left', '131px');
      if (self.$postMessage.hasClass('default')) {
        self.resetTextArea();
      }

      // If the user requires approval, we don't require approval if the post is
      // just an approved asset with no text.
      if (self.requiresApproval) {
        // All assets are approved
        self.togglePostBoxSubmitButtonMessage(self.calculateMessageLength() === 0);
        $img.data('approved', true);
      }

      if (!shoulUploadFile) {
        var photoUploadData = {
          'croppedImage': croppedImage,
          'croppedImageName': fileName,
          'sourceUrl': sourceUrl,
          'photoUrl': photoUrl,
          'assetId': assetId,
        };

        self.uploadPhotoAjaxRequest = $.ajax({
          url: yext.socialstorm.routes.SocialPost.uploadPhoto(),
          type: 'POST',
          data: photoUploadData,
          success: self.uploadPhotoDone.bind(self),
          error: self.uploadPhotoDone.bind(self),
        });
      }

      self.maybeEnableSubmit();
    });
  });

  this.$postForm.delegate('.fb-remove-photo', 'click', function() {
    self.removePhoto();
    if (self.$postMessage.hasClass('default')) {
      self.resetTextArea();
    }

    if (self.requiresApproval) {
      self.togglePostBoxSubmitButtonMessage(false);
      $img.data('approved', false);
    }

    self.maybeEnableSubmit();
  });
};

/**
 * Listens for user input on textarea
 */
yext.social.PostBox.prototype.bindInputListener = function() {
  var self = this;
  var $img = this.$postBox.find('.fb-photo-wrapper').find('img');

  // For YCPs, the post box begins with no locations selected and the post button
  // remains disabled until a folder or location(s) is selected.
  if (this.$postBox.find('#ycp-select-msg').length) {
    this.changeSubmitTooltipMessageForYCP();
  }
  this.togglePostBoxSubmitButton(false);

  this.$postMessage.bind('focus input keyup', function() {
    if (self.$postMessage.hasClass('default')) {
      self.$postMessage.removeClass('default');
    }

    if (self.requiresApproval) {
      self.togglePostBoxSubmitButtonMessage(
        $img.data('approved') && self.calculateMessageLength() === 0);
    }

    self.maybeEnableSubmit();
    self.updateCharCount();
  });

  self.$postMessage.blur(function() {
    if (self.$postMessage.val().length === 0) {
      self.resetTextArea();
      self.maybeEnableSubmit();
    }
  });
};

/*
 * Prepopulates the date in the textbox
 */
yext.social.PostBox.prototype.setTextArea = function(message) {
  this.$postMessage.val(message).removeClass('default');
  this.togglePostBoxSubmitButton(true);
};

/**
 * Get social post message input by user and show appropriate error dialogs
 */
yext.social.PostBox.prototype.getMessage = function() {
  var self = this;
  var message = this.$postMessage.val();

  if (message.length > 5000) {
    var errorMsg = yext.msg('Exceeded maximum message size of 5000 characters. ' +
                            'Please remove {0} characters.',
    (message.length - 5000));
    yext.dialog.showErrorDialog(errorMsg,
      yext.msg('Exceeded max message length'));
    return null;
  }
  return message;
};

/*
 * Clears the Postbox of an data inside it
 */
yext.social.PostBox.prototype.resetPostBox = function() {
  this.removePhoto();
  this.resetTextArea();
  this.resetLink();
  if (this.options.hasScheduledPosting) {
    this.scheduledPostDialog.resetSchedule();
  }
};

/**
 * Make AJAX call to create social post and perform file upload
 *
 * @param {!Object} opts options with information about missing accounts, permissions, etc.
 */
yext.social.PostBox.prototype.submitPost = function(opts) {
  var self = this;
  var asset = self.asset;

  this.$postSubmitBtn.trigger('mouseover')
    .attr('title', yext.msg('Creating your post...'))
    .tooltip('fixTitle')
    .tooltip('enable');
  this.togglePostBoxSubmitButton(false);
  self.progressTimeoutId_ = yext.dialog.showDelayedProgressDialog(yext.msg('Posting...'));
  // abort any outstanding ajax request
  self.abortPhotoUploadAjaxRequest();

  var submitPostError = function(status) {
    if (status === 504 /* timeout exception */ ) {
      this.error({
        'error': yext.msg('It seems like your post is taking a while. ' +
                           'Please try refreshing this page in a few minutes.'),
      }, opts);
      self.resetPostBox();
    } else {
      this.error();
    }

    yext.dialog.hideDelayedProgressDialog(self.progressTimeoutId_);
  }.bind(this);

  var submitPostDone = function(data) {
    if (data.success) {
      this.successDialog.open(data);
      self.resetPostBox();
      $.event.trigger('newPost.social', [data]);
    } else {
      this.error(data);
      yext.notify.showError(yext.msg('Post failed.'));
    }

    yext.dialog.hideDelayedProgressDialog(self.progressTimeoutId_);
  }.bind(this);

  var upload = {};
  upload.action = self.options.postUrl;
  upload.data = self.getData(opts);

  if (asset && asset.file) {
    upload.dataType = 'json';
    upload.files = [asset.file];
    upload.fileInputs = [asset.fileInput];

    upload.done = function(data) {
      submitPostDone(data);
    };

    upload.error = function(response) {
      submitPostError(response.status);
      yext.notify.showError(yext.msg('Image upload failed.'));
    };

    yext.fileupload.upload(upload);
  } else {
    if (asset && !asset.id) {
      upload.data.push({
        name: 'sourceUrl',
        value: asset.sourceUrl,
      });
    }

    var data = {
      'success': true,
      'failCount': 3,
      'requiresApproval': false,
      'socialPostId': 34234234,
    };

    // submitPostDone(data);
    $.ajax({
      url: self.options.postUrl,
      data: upload.data,
      type: 'POST',
      success: submitPostDone,
      error: submitPostError,
    });
  }
};

/**
 * Get data needed for ajax call to create social post
 *
 * @param {!Object} opts options with information about missing accounts, permissions, etc.
 */
yext.social.PostBox.prototype.getData = function(opts) {
  var self = this;
  var message = self.getMessage();

  opts = opts || {};

  var folderId = this.$postForm.find('#folderId').val();
  var locationId = this.$postForm.find('#locationId').val();
  var usesSelector = this.$postForm.find('#usesSelector').val();
  var shareReview = this.$postForm.find('#shareReview').val();
  var sourcePostId = this.$postForm.find('#sourcePostId').val();
  var linkTitle = this.$postForm.find('.fb-link-area .fb-link-title').text();
  var linkSubtitle = this.$postForm.find('.fb-link-area .fb-link-subtitle').text();
  var linkSummary = this.$postForm.find('.fb-link-area .fb-link-summary').text();
  var targetPartners = self.getTargetPartners();
  var scheduledPostDate = this.$postForm.find('#scheduledPostDate').val();
  var photoUrl = self.uploadedPhotoUrl;
  var photoWidth = self.photoWidth;
  var photoHeight = self.photoHeight;

  var data = [
    {name: 'message', value: message},
    {name: 'folderId', value: folderId},
    {name: 'locationId', value: locationId},
    {name: 'force', value: !!opts.force},
    {name: 'emptyForce', value: !!opts.emptyForce},
    {name: 'emptySkip', value: !!opts.emptySkip},
    {name: 'usesSelector', value: usesSelector},
    {name: 'permissionsForce', value: !!opts.permissionsForce},
    {name: 'linkTitle', value: linkTitle},
    {name: 'linkSubtitle', value: linkSubtitle},
    {name: 'linkSummary', value: linkSummary},
    {name: 'shareReview', value: shareReview},
    {name: 'targetPartners', value: targetPartners},
    {name: 'sourcePostId', value: sourcePostId},
  ];

  if (photoUrl) {
    data.push({name: 'photoUrl', value: photoUrl});
    data.push({name: 'photoWidth', value: photoWidth});
    data.push({name: 'photoHeight', value: photoHeight});
  }

  if (self.url_) {
    data.push({
      name: 'link',
      value: self.url_,
    });
  }

  if (self.croppedImage) {
    data.push({
      name: 'croppedImage',
      value: self.croppedImage.encodedString,
    });

    data.push({
      name: 'croppedImageName',
      value: self.croppedImage.fileName,
    });
  } else if (self.asset && self.asset.photoUrl && !photoUrl) {
    data.push({
      name: 'photoUrl',
      value: self.asset.photoUrl,
    });

    if (self.asset.id) {
      data.push({
        name: 'assetId',
        value: self.asset.id,
      });
    }
  }

  if (scheduledPostDate) {
    data.push({name: 'scheduledPostDate', value: scheduledPostDate});
  }

  if (this.scheduledPostDialog) {
    if (this.scheduledPostDialog.userTimeZone) {
      data.push({name: 'userTimeZoneId', value: this.scheduledPostDialog.userTimeZone});
    }

    if (this.scheduledPostDialog.destinationTimeZone) {
      data.push({
        name: 'destinationTimeZoneId',
        value: this.scheduledPostDialog.destinationTimeZone,
      });
    }
  }

  return data;
};

/**
 * This method should be called whenever the networks to post to may have changed.
 */
yext.social.PostBox.prototype.updatePartnerStatus = function() {
  this.updateProfileField();
  this.maybeEnableSubmit();
  this.updateCharCount();
};

yext.social.PostBox.prototype.selectPreferredSocialNetworks = function() {
  if (window.preferredSocialNetworks && window.preferredSocialNetworks.length > 0) {
    $('.social-partner-icon').each(function(i, f) {
      var $field = $(f);
      var flag = $field.hasClass('disabled');
      if ($.inArray($field.data('value'), window.preferredSocialNetworks) > -1) {
        if (flag) {
          $field.removeClass('disabled');
        }
      } else {
        if (!flag) {
          $field.addClass('disabled');
        }
      }
    });
  }
  this.updatePartnerStatus();
};

/**
 * Binds Profile Field Controls
 */
yext.social.PostBox.prototype.bindProfileFields = function() {
  var self = this;

  $('.fb-profile-field-select')
    .change(function(event, isDisableStateChange) {
      // We don't want to put embedded fields in the text box
      // if this was triggered by a profile field button
      // state change (e.g. the button was disabled).
      if (isDisableStateChange) {
        return;
      }

      var placeholder = '[' + $(this).val() + ']';
      setTimeout(function() {
        if (self.$postMessage.hasClass('default')) {
          self.$postMessage.val('').removeClass('default');
        }

        var val = self.$postMessage.val();
        if (val.length === 0 || /\s$/.test(val)) {
          val = val + placeholder;
        } else {
          val = val + ' ' + placeholder;
        }
        self.$postMessage.focus().val(val);
        self.maybeEnableSubmit();
      }, 0);
    });
  if (!$('.fb-profile-field-select').attr('disabled')) {
    $('.fb-profile-field').tooltip('disable');
  }
};

/**
 * Disables the profile field if foursquare, twitter or herold is
 * selected
 */
yext.social.PostBox.prototype.updateProfileField = function() {
  var shouldDisable = this.shouldDisableLocationFields();
  var $profileField = this.$postBox.find('.fb-profile-field');

  $('.fb-profile-field-select').attr('disabled', shouldDisable).trigger('change', true);

  if (shouldDisable) {
    $profileField.tooltip('enable');
  } else {
    $profileField.tooltip('disable');
  }
};

/**
 * Removes Photo and data from postbox
 */
yext.social.PostBox.prototype.removePhoto = function() {
  this.asset = {};
  this.removeUploadedPhoto();
  this.$postBox.find('.fb-photo-wrapper').removeData('data');
  this.$postBox.find('.js-gallery-add-photo').show();
  this.$postBox.find('.fb-replace').hide();
  this.$postBox.find('.fb-photo-wrapper').hide();
  this.croppedImage = null;
  this.asset = null;


  var $message = this.$postBox.find('.fb-post-wrapper');
  var $photo = this.$postBox.find('.fb-photo-wrapper');
  var $img = $photo.find('img');
  $message.css('margin-left', '0');
  $img.removeAttr('src');
  this.hasPhoto_ = false;
  this.photoUrl_ = null;
  this.lookForUrls_ = true;
};

yext.social.PostBox.prototype.removeUploadedPhoto = function() {
  this.uploadedPhotoUrl = null;
  this.photoWidth = null;
  this.photoHeight = null;
};

/**
 * Resets the Text Area to its original state
 */
yext.social.PostBox.prototype.resetTextArea = function() {
  var message = this.hasPhoto_
    ? yext.msg('Say something about this photo...')
    : yext.msg('Make a new post...');
  this.$postMessage.addClass('default').prop('placeholder', message).val('');
  this.$postForm.find('.submit').addClass('disabled btn-disabled');
};

/**
 * Removes Link and data from PostBox
 */
yext.social.PostBox.prototype.resetLink = function() {
  this.url_ = null;
  this.lookForUrls_ = !this.hasPhoto_;
  this.$postBox.find('.fb-link-area').hide();
  this.$postBox.find('.fb-link-photo').removeClass('disabled');
  this.maybeEnableSubmit();
  this.updateCharCount();
};

/**
 * Checks if a post is ready to submit, i.e. has content, or image and networks selected
 *
 * @returns {boolean} True if the content of post is valid enough to post
 */
yext.social.PostBox.prototype.maybeEnableSubmit = function() {
  var $submit = this.$postForm.find('.submit');
  var validInput = false;

  if (/[^\s]/.test(this.$postMessage.val()) && !this.$postMessage.hasClass('default')) {
    validInput = true;
  }

  if (this.url_) {
    validInput = true;
  }

  if (this.hasPhoto_) {
    // just having a photo is not enough to validate a Herold post
    if (!this.hasHerold()) {
      validInput = true;
    }
  }

  if (!$('.social-partner-icon:visible:not(.disabled)').length) {
    validInput = false;
  }

  if (!this.checkValidLength()) {
    validInput = false;
  }

  if (this.$postBox.find('#ycp-select-msg').length) {
    validInput = false;
    this.changeSubmitTooltipMessageForYCP();
  }

  this.togglePostBoxSubmitButton(validInput);

  return validInput;
};

/* Changes the contextual help message */
yext.social.PostBox.prototype.changeSubmitTooltipMessageForYCP = function() {
  this.$postSubmitBtn.trigger('mouseover');
  this.$postSubmitBtn.attr('title', yext.msg('Please select one or more locations.'));
  this.$postSubmitBtn.tooltip('fixTitle');
  this.$postSubmitBtn.tooltip('enable');
};

yext.social.PostBox.prototype.togglePostBoxSubmitButton = function(enabled) {
  var disabledButtonClasses = 'disabled btn-disabled';
  this.$postBox.find('.js-post-box-actions .js-post-box-action')
    .toggleClass(disabledButtonClasses, !enabled);

  this.togglePostBoxTooltip(enabled);
};

/* Sets the post button text based on whether approval is required or not */
yext.social.PostBox.prototype.togglePostBoxSubmitButtonMessage = function(approved) {
  var $submitBtnText = this.$postSubmitBtn.find('span');
  if (approved) {
    $submitBtnText.text(yext.msg('Post'));
    this.showMinSubmitTooltipMessage(); // or else the tooltip message will be positioned weirdly
  } else {
    $submitBtnText.text(yext.msg('Submit for Approval'));
  }
};

/**
 * Disabling the postbox tooltip if the button is enabled
 */
yext.social.PostBox.prototype.togglePostBoxTooltip = function(disableTooltip) {
  var $postButton = this.$postBox.find('.js-post-box-actions .js-post-box-action');
  if (disableTooltip) {
    $postButton.trigger('mouseout');
    $postButton.tooltip('disable');
  } else {
    $postButton.tooltip('enable');
    $postButton.tooltip('show');
  }
};

/**
 * Checks if post message is over length, takes into account length of url when one is 'embedded'
 *
 * @return Integer count Count of remaining characters for post message
 */
yext.social.PostBox.prototype.postMessageRemainingCharacters = function() {
  var maxChars = this.determineMaxChars();
  var count = maxChars - this.calculateMessageLength();

  if (this.$postMessage.hasClass('default')) {
    count = maxChars;
  }

  if (this.url_) {
    var tester = this.url_;

    if (tester.indexOf('https://') == 0) {
      tester = tester.substring('https://'.length);
    }

    if (tester.indexOf('http://') == 0) {
      tester = tester.substring('http://'.length);
    }

    if (this.$postMessage.val().indexOf(tester) == -1) {
      count -= this.url_.length;
      if (this.$postMessage.val().length) {
        count--;
      }
    }
  }
  return count;
};

yext.social.PostBox.prototype.calculateMessageLength = function() {
  var message = this.getMessage();

  if (message) {
    return this.getMessage().length;
  } else {
    return 0;
  }
};

/**
 * Get selected partners to send social post
 */
yext.social.PostBox.prototype.getTargetPartners = function() {
  var targetPartners = [];
  var selectedPartners = this.$postForm.find('.social-partner-icon:not(.disabled):visible');

  $.each(selectedPartners, function(i, e) {
    targetPartners.push($(e).data('value'));
  });
  return targetPartners;
};

/**
 * Returns true if the amount of characters in the post are a
 * valid length for a post based on the required min and max values
 * depending on the given partner
 * Also, update the submit tooltip.
 */
yext.social.PostBox.prototype.checkValidLength = function() {
  var maxChars = this.determineMaxChars();
  var minChars = this.determineMinChars();

  // get the current character typed in the post box
  var currentCharCount = this.calculateMessageLength();
  var remainingCount = maxChars - currentCharCount;
  var hasUrlOrPhoto = this.url_ || this.hasPhoto_;

  if (maxChars) {
    if (remainingCount < 0) {
      this.showMaxSubmitTooltipMessage();
      return false;
    }
  }
  // TODO: smosharrof - Uncomment when foursquare posting rule is confirmed.
  // if (hasUrlOrPhoto && count == 0) {
  //  return true;
  // }
  if (minChars) {
    if (currentCharCount < minChars) {
      // show tooltip warning
      this.showMinSubmitTooltipMessage();
      return false;
    }
  }
  // remove tooltip warning for minChar length
  this.removeSubmitTooltip();
  return true;
};

/**
 * modifies the submit button tooltip
 * based on the selected networks
 */
yext.social.PostBox.prototype.showMinSubmitTooltipMessage = function() {
  var forbiddenPartners = [];

  if (this.hasFoursquare()) {
    forbiddenPartners.push('Foursquare');
  }
  if (this.hasHerold()) {
    forbiddenPartners.push('Herold');
  }

  if (forbiddenPartners.length > 0) {
    this.$postSubmitBtn.trigger('mouseover');
    // TRANSLATORS: Parameter is a list of social networks
    this.$postSubmitBtn.attr(
      'title',
      yext.msg('Updates must contain at least 10 characters on: {0}', forbiddenPartners.join()));
    this.$postSubmitBtn.tooltip('fixTitle');
    this.$postSubmitBtn.tooltip('enable');
  }
};


/**
 * modifies the submit button tooltip
 * based on the max number of characters
 * allowed in the target partner
 */
yext.social.PostBox.prototype.showMaxSubmitTooltipMessage = function() {
  var maxChars = this.determineMaxChars();

  if (maxChars) {
    this.$postSubmitBtn.trigger('mouseover');
    // TRANSLATORS: Parameter is a list of social networks
    this.$postSubmitBtn.attr('title', yext.msg('Max character length reached: {0}', maxChars));
    this.$postSubmitBtn.tooltip('fixTitle');
    this.$postSubmitBtn.tooltip('enable');
  }
};

/**
 * removes the tooltip on the submit button and
 */
yext.social.PostBox.prototype.removeSubmitTooltip = function() {
  this.$postSubmitBtn.trigger('mouseout')
    .tooltip('disable')
    .attr('title', yext.msg('Start typing to get started.'))
    .tooltip('fixTitle');
};

/** *** Utilities *****/

/**
 * Determines where to
 * @return {boolean} returns true if the location field should be disabled
 */
yext.social.PostBox.prototype.shouldDisableLocationFields = function() {
  // find out if any of the the targetPartners contains the disabledLocationFields values
  var targetPartners = this.getTargetPartners();

  // if we can't find either of those permissions, just don't disable the fields
  if (!yext.social.PostBox.socialPermissions
      || !yext.social.PostBox.socialPermissions.disabledLocationFields) {
    return false;
  }

  // filter will get the intersection between the two arrays
  var selectedPartnersWithoutLocationFields = $(targetPartners).filter(
    yext.social.PostBox.socialPermissions.disabledLocationFields);
  return selectedPartnersWithoutLocationFields.length > 0;
};

/**
 * Determines if the selected partner is listed
 * @param  {string}  partnerName the partner name as a string
 * @return {boolean} indicated if the partner is in the string
 */
yext.social.PostBox.prototype.hasPartner = function(partner) {
  // get the partner from the helper defined in post-box.html
  var partnerId = parseInt(partner);
  if (partnerId && yext.isNumber(partnerId)) {
    return $.inArray(partnerId, this.getTargetPartners()) >= 0;
  }
};

/**
 *
 * @return {boolean} true if the targetPartners contain Herold
 */
yext.social.PostBox.prototype.hasHerold = function() {
  return this.hasPartner(648);
};

/**
 *
 * @return {boolean} true if the targetPartners contain Foursquare
 */
yext.social.PostBox.prototype.hasFoursquare = function() {
  return this.hasPartner(440);
};

/**
 *
 * @return {boolean} return if the targetPartners contain Twitter
 */
yext.social.PostBox.prototype.hasTwitter = function() {
  return this.hasPartner(689);
};

/**
 * Updates Char counter in the postbox
 */
yext.social.PostBox.prototype.updateCharCount = function() {
  var $charCount = this.$postBox.find('.js-char-count');
  var count;

  if (this.determineMaxChars() > 0) {
    count = this.postMessageRemainingCharacters();
    $charCount.show().toggleClass('overcount', count < 0).html(count);
  } else {
    $charCount.hide();
  }
};

/**
 * Gets the lowest number of max characters allowed in a post
 * @return {number} max allowed characters
 */
yext.social.PostBox.prototype.determineMaxChars = function() {
  var maxCharsAllowed = [];
  var self = this;
  var hasImage = this.$postBox.find('.fb-photo-wrapper').is(':visible');

  // if there are no socialPermissions, just return null for MaxChars
  if (!yext.social.PostBox.socialPermissions
      || !yext.social.PostBox.socialPermissions.locationsWithMaxChars) {
    return null;
  }

  $.each(yext.social.PostBox.socialPermissions.locationsWithMaxChars, function() {
    var partnerId = this;
    var partner = yext.social.PostBox.socialPartners[partnerId];

    if (partner && self.hasPartner(partnerId)) {
      maxCharsAllowed.push(partner.maxChars);
    }
    // Twitter max char is 116 if there is any media attached
    if (partnerId == 689 && hasImage && self.hasPartner(partnerId)) {
      maxCharsAllowed.push(116);
    }
  });

  if (maxCharsAllowed.length > 0) {
    if (maxCharsAllowed.length == 1) {
      return maxCharsAllowed[0];
    } else {
      return Math.min.apply(Math, maxCharsAllowed);
    }
  } else {
    return null;
  }
};

/**
 * Gets the highest number of min characters allowed in a post
 * @return {number} min allowed characters
 */
yext.social.PostBox.prototype.determineMinChars = function() {
  var minCharsRequired = [];
  var self = this;

  // if there are no socialPermissions, just return null for minChars
  if (!yext.social.PostBox.socialPermissions
      || !yext.social.PostBox.socialPermissions.locationsWithMinChars) {
    return null;
  }

  $.each(yext.social.PostBox.socialPermissions.locationsWithMinChars, function() {
    var partnerId = this;
    var partner = yext.social.PostBox.socialPartners[partnerId];

    if (partner && self.hasPartner(partnerId)) {
      minCharsRequired.push(partner.minChars);
    }
  });

  if (minCharsRequired.length > 0) {
    if (minCharsRequired.length == 1) {
      return minCharsRequired[0];
    } else {
      return Math.max.apply(Math, minCharsRequired);
    }
  } else {
    return null;
  }
};

/**
 * If a url is detected returns the thumbnails
 */
yext.social.PostBox.prototype.urlDetected = function(url, showLoading) {
  if (this.url_ || !this.lookForUrls_) {
    return;
  }

  $('.fb-link-photo').addClass('disabled');
  $('.fb-post-loading').show();
  var urlToLoad = url;
  if (!/^https?:\/\//i.test(urlToLoad)) {
    urlToLoad = 'http://' + urlToLoad;
  }

  var $linkArea = $('.fb-link-area');
  if (!!showLoading) {
    this.url_ = url;
    this.lookForUrls_ = false;
    $linkArea.find('.fb-link-title').text(yext.msg('Loading...'));
    $linkArea.find('.fb-link-subtitle').text(urlToLoad);
    $linkArea.find('.fb-link-summary').text('');
    $linkArea.show();
  }

  yext.social.post.actions.fetchLinkMetadata({
    url: urlToLoad,
    onSuccess: function(data) {
      yext.social.PostBox.checkForYouTubeAppendThumbnail($linkArea, data['subtitle']);
      $linkArea.find('.fb-link-title').text(data['title']);
      $linkArea.find('.fb-link-subtitle').text(data['subtitle']);
      $linkArea.find('.fb-link-summary').text(data['description']);
    },
    onFail: function() {
      $linkArea.find('.fb-link-title').text(urlToLoad);
      $linkArea.find('.fb-link-subtitle').text(urlToLoad);
      $linkArea.find('.fb-link-summary').text('');
    },
    onAlways: function() {
      this.url_ = url;
      this.lookForUrls_ = false;
      $('.fb-post-loading').hide();
      $linkArea.show();
      this.maybeEnableSubmit();
    }.bind(this),
  });
};

/**
 * Sets the postbox textarea as focus
 */
yext.social.PostBox.prototype.setFocus = function() {
  this.$postMessage.focus();
};

yext.social.PostBox.prototype.updateIcons = function(partners, hasWidget) {
  if (partners) {
    for (var i = 0; i < partners.length; i++) {
      $('.social-partner-icon.logo-' + partners[i]).show();
    }
  }

  if (hasWidget) {
    yext.social.PostBox.toggleWidgetIcon(false);
  }
  this.updatePartnerStatus();
};

/**
 * Checks for a link container, finds the url and checks if its youtube,
 * appends the thumbnail if it exists
 *
 * @param {!jQuery} $linkBox a link container
 * @param {string} url The link container's url
 */
yext.social.PostBox.checkForYouTubeAppendThumbnail = function($linkBox, url) {
  if ($linkBox.length > 0) {
    var $youtubeContainer = $linkBox.find('.fb-youtube-thumbnail');
    var videoID = yext.youtube.parseIdFromUrl(url);
    $youtubeContainer.html('');
    if (videoID) {
      $youtubeContainer.append(
        '<a target="_blank" href="' + url + '">' +
          '<img src="' + yext.youtube.getYoutubeThumbnailUrl(videoID) + '"/>' +
        '</a>');
    }
  }
};

/**
 * Show error dialog when social post is not created
 *
 * @param {!Object} data Response data from creating social post
 * @param {!Object} opts options with information about missing accounts, permissions, etc.
 */
yext.social.PostBox.prototype.error = function(data, opts) {
  yext.dialog.hideDelayedProgressDialog(self.progressTimeoutId_);
  data = data || {};
  if (data.missingAccounts) {
    if (data.linkedAccounts > 0) {
      this.missingAccountsDialog.open(data, opts);
    } else {
      this.noLinkedAccountDialog.open();
    }
  } else if (data.reauth > 0) {
    $('#post-reauth-dialog').dialog('open');
  } else if (data.emptyCount > 0) {
    this.missingFieldsDialog.open(data, opts);
  } else if (data.missingPermissions > 0) {
    this.missingPermissionsDialog.open(data, opts);
  } else if (data.duplicate > 0) {
    $('#post-duplicate-dialog').dialog('open');
  } else {
    var error = yext.msg('An unexpected error occurred. ' +
                         'Try again later, or contact support for further assistance.');
    if (typeof data.error === 'string') {
      error = data.error;
    }
    yext.dialog.showErrorDialog(error);
  }
};

/**
  * Toggles a widget Icon
  * @param {boolean} isDisabled Whether or not the widget icons isDisabled
  */
yext.social.PostBox.toggleWidgetIcon = function(isDisabled) {
  $('.social-partner-icon.logo-' + window.WIDGETS_ID).toggleClass('active', !isDisabled);
  $('.social-partner-icon.logo-' + window.WIDGETS_ID).toggleClass('inactive', isDisabled);
};

goog.exportSymbol('yext.social.PostBox', yext.social.PostBox);
goog.exportSymbol('yext.social.PostBox.init', yext.social.PostBox.init);
goog.exportSymbol('yext.social.SocialPartner', yext.social.SocialPartner);
goog.exportSymbol('yext.social.SocialPermissions', yext.social.SocialPermissions);
